import { useContext } from "react"
import { AuthContext } from "../context/auth"

export default function useAccountType() {
    const { accountType } = useContext(AuthContext)
    return accountType
}
